import { ContractErrorCode, ContractsData } from 'cpnl-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { ContractsDataSelector } from './ContractsDataSelector';
import { fetchContracts } from './ContractsSlice';

export function useContracts(): AbstractDataState<ContractsData, ContractErrorCode> {
    return useGetSimpleApiData(fetchContracts, ContractsDataSelector);
}
